import { useCallback, useEffect } from 'react';
import { usePathname, useRouter } from 'expo-router';
import { Platform } from 'react-native';

import { useGroupOrderingState } from '../../hooks/useGroupOrderingState';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Hosts group-order synchronization and opens the terminal-state screen.
 */
export const GroupOrderEffects = () => {
  const router = useRouter();
  const pathname = usePathname();
  const { terminalGroupOrder, clearTerminalGroupOrder } = useGroupOrderingState();

  // ─── Handlers ──────────────────────────────────────────────────────────────

  const showTerminalGroupOrder = useCallback(() => {
    if (!terminalGroupOrder) {
      return;
    }

    const href = {
      pathname: '/group-order-ended/[orderId]',
      params: { orderId: terminalGroupOrder.id },
    } as const;

    // NOTE: A web reload restores the screen from the URL, so it is already open.
    const isAlreadyShown = pathname === `/group-order-ended/${terminalGroupOrder.id}`;

    clearTerminalGroupOrder();

    if (isAlreadyShown) {
      return;
    }

    // NOTE: Deferred like the group-order reset so it runs after it, since the
    //       reset can dismiss the modal stacks this screen is pushed onto.
    function navigate() {
      router.push(href);
    }

    if (Platform.OS === 'web') {
      setTimeout(navigate);

      return;
    }

    requestIdleCallback(navigate);
  }, [clearTerminalGroupOrder, pathname, router, terminalGroupOrder]);

  // ─── Effects ───────────────────────────────────────────────────────────────

  useEffect(showTerminalGroupOrder, [showTerminalGroupOrder]);

  return null;
};
